import { render, staticRenderFns } from "./PersonLoginForm.vue?vue&type=template&id=da1f5c6e&scoped=true&"
import script from "./PersonLoginForm.vue?vue&type=script&lang=js&"
export * from "./PersonLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./PersonLoginForm.vue?vue&type=style&index=0&id=da1f5c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1f5c6e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default,Form: require('/workspace/components/Form/index.js').default})
